import React from "react";
import { Outlet } from "react-router-dom";
import "../assets/css/InBody.scss";
import logo from "../assets/img/InBody-logo.png";

const RootContainer = () => {
  return (
    <>
      <div className="panel-container">
        <div className="panel">
          <div className="logo-container">
            <img src={logo} alt="InBodyLogo" height="25px" />
          </div>
          <div className="halo-gradient"></div>
          <div className="background-image"></div>
          <div className="panel-inner">
            <h1 style={{ textAlign: "center" }}>
              {process.env.NODE_ENV === "development"
                ? process.env.NODE_ENV.toUpperCase()
                : ""}
            </h1>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default RootContainer;
